__turbopack_context__.v({
  "root": "Skeleton-module__2afL-G__root",
});
